import { SERVER_URL } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
export class AnalyticsService {
    constructor(http, authService) {
        this.http = http;
        this.authService = authService;
        this.web = "web";
    }
    AnalyticsPageView(param) {
        console.log('PAGE VIEW');
        const url = SERVER_URL + '/analytics/log/';
        const headers = this.authService.getAuthHeaders();
        let data = {
            "channel": this.web,
            "action": "page_view",
            "page": param,
        };
        return this.http.post(url, data, headers).toPromise();
    }
    AnalyticsServiceModalView(param) {
        console.log('MODAL VIEW');
        const url = SERVER_URL + '/analytics/log/';
        const headers = this.authService.getAuthHeaders();
        let data = {
            "channel": this.web,
            "action": "page_view",
            "page": "Modal: " + param,
        };
        return this.http.post(url, data, headers).toPromise();
    }
    AnalyticsServiceProductDetail(id) {
        console.log('PRODUCT VIEW');
        const url = SERVER_URL + '/analytics/log/';
        const headers = this.authService.getAuthHeaders();
        let data = {
            "channel": this.web,
            "action": "view_product",
            "params": {
                "product_id": id
            }
        };
        return this.http.post(url, data, headers).toPromise();
    }
    AnalyticsServiceAddToCart(id) {
        console.log('ADD TO CART');
        const url = SERVER_URL + '/analytics/log/';
        const headers = this.authService.getAuthHeaders();
        let data = {
            "channel": this.web,
            "action": "add_to_cart",
            "params": {
                "product_id": id
            }
        };
        return this.http.post(url, data, headers).toPromise();
    }
    AnalitycsServiceLogin() {
        console.log('LOGIN');
        const url = SERVER_URL + '/analytics/log/';
        const headers = this.authService.getAuthHeaders();
        let data = {
            "channel": this.web,
            "action": "login",
        };
        return this.http.post(url, data, headers).toPromise();
    }
    AnalyticsServiceLogout() {
        console.log('LOGOUT');
        const url = SERVER_URL + '/analytics/log/';
        const headers = this.authService.getAuthHeaders();
        let data = {
            "channel": this.web,
            "action": "logout",
        };
        return this.http.post(url, data, headers).toPromise();
    }
    AnalyticsServiceError(error, trace) {
        const url = SERVER_URL + '/analytics/log/';
        const headers = this.authService.getAuthHeaders();
        let data = {
            "channel": this.web,
            "action": "error",
            "params": {
                "error": error,
                "trace": trace
            }
        };
        return this.http.post(url, data, headers).toPromise();
    }
}
AnalyticsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnalyticsService_Factory() { return new AnalyticsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService)); }, token: AnalyticsService, providedIn: "root" });
